const appearancesInPast = (appearances) => {

  if (appearances == null) {
    return false;
  }

  // Transform single values into arrays
  if (!Array.isArray(appearances)) {
    appearances = [appearances];
  }

  // Filter for unexpected null values
  const validAppearances = appearances.filter(Boolean);

  // Do nothing if there afe no validAppearances
  if (validAppearances.length === 0) {
    return false;
  }

  const now = Math.floor(Date.now() / 1000);

  // Check if all Events are in past
  const allInPast = validAppearances.every(item => {
    const timestamp = Number(item.fieldDateRawField.first.value);
    return !isNaN(timestamp) && timestamp < now;
  });

  return allInPast;
};

export default appearancesInPast;
